import { render } from "./permissions-page.vue?vue&type=template&id=46241fb6&ts=true"
import script from "./permissions-page.ts?vue&type=script&lang=ts"
export * from "./permissions-page.ts?vue&type=script&lang=ts"

import "./permissions-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__